import request from '../libs/request';

const BASE_URL = '/price-ranges';

export const getPriceRanges = async () => {
  return await request({
    resource: `${BASE_URL}`,
  });
};
